import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { CurtainChangedEvent } from '../../../../shared/events/cutains-changed.event';
import { CurtainActionsUnion, CurtainActionTypes } from './curtains.actions';

export const inRoomCurtainsFeatureKey = 'inroom-curtains';

export type CurtainState = EntityState<CurtainChangedEvent>;

export function selectCurtainIdFromCurtain(fanspeed: CurtainChangedEvent) {
  return selectCurtainId(fanspeed.HotelCode, fanspeed.Room);
}

export function selectCurtainId(hotelCode: string, room: string) {
  return hotelCode + '-' + room;
}

export const adapter: EntityAdapter<CurtainChangedEvent> = createEntityAdapter<CurtainChangedEvent>({
  selectId: selectCurtainIdFromCurtain,
});

export const initialState: CurtainState = adapter.getInitialState();

export function curtainsReducer(state: CurtainState = initialState, action: CurtainActionsUnion) {
  switch (action.type) {
    case CurtainActionTypes.UPDATE_CURTAIN:
      return adapter.upsertOne(action.payload, state);
    default:
      return state;
  }
}

const { selectIds, selectEntities } = adapter.getSelectors();

export const selectCurtainIds = selectIds;

export const selectCurtainEntities = selectEntities;
